import { skipToken, useMutation, useQuery } from '@tanstack/react-query'
import { UpdateMeetingRequest } from '@chilipiper/api-client/src/meetings-api'
import { useApiClient } from '@chilipiper/api-client/src/context'
import { MeetingResponseDiscriminator } from '@chilipiper/api-client/src/meetings-api'

const getRescheduleErrorMessage = (type: MeetingResponseDiscriminator) => {
  switch (type) {
    case 'Disabled':
      return 'This scheduling link is disabled'
    case 'NoAvailableAssignees':
      return 'No Available assignees'
    case 'ProspectLimitReached':
      return 'Prospect Limit Reached'
    case 'AlreadyBooked':
      return 'This meeting is already scheduled'
    case 'AlreadyAccepted':
      return 'This meeting is already accepted'
    case 'Accepted':
      return 'This meeting is already accepted'
    case 'ReservationFailure':
      return 'There was an error on rescheduling the meeting'
  }
}

export const useRescheduleMeeting = () => {
  const { meetingsApi } = useApiClient()
  return useMutation({
    mutationFn: ({
      tenantId,
      meetingId,
      payload,
    }: {
      tenantId: string
      meetingId: string
      payload: UpdateMeetingRequest
    }) => {
      return meetingsApi.updateAMeetingGuestEndpoint(tenantId, meetingId, payload).then(result => {
        if (result.type === 'Accepted' || result.type === 'NoAvailableAssignees') {
          return result
        }

        const errorMessage = getRescheduleErrorMessage(result.type)
        throw new Error(errorMessage)
      })
    },
  })
}

export const useMeetingSettings = ({
  tenantId,
  meetingId,
}: {
  tenantId?: string
  meetingId?: string
}) => {
  const { meetingsApi } = useApiClient()
  return useQuery({
    queryKey: [tenantId, meetingId, 'meetings-platform/meeting-settings'],
    queryFn:
      tenantId && meetingId
        ? () => meetingsApi.getMeetingConfiguration(tenantId, meetingId)
        : skipToken,
  })
}
